<div>
  Everything is ready for you to start working.<br />
  you can start planning your broadcast in your scheduler.<br />
  apply automatic rules with the autopilot feature, check out<br />
  your channel analytics and more!
</div>
<div class="buttons">
  <a
    *ngIf="currentUser && channel && currentUser.hasEditSchedulePermission(channel)"
    (click)="takeToScheduler()"
    ><div id="schedulerButton" class="button">Take Me To My Scheduler</div></a
  >
  <a
    *ngIf="currentUser && channel && currentUser.hasEditChannelSettingsPermission(channel) && isCreate"
    [routerLink]="'/channels/edit/' + channel.id"
    ><div class="button edit">Edit Channel Settings</div></a
  >
</div>
